export const ARIA_LABEL_TEXT = "Поделиться";
export const VK_SHARE_URL = "https://vk.com/share.php?url=";
export const TELEGRAM_SHARE_URL = "https://t.me/share/url?url=";